import React, { useState } from "react";
import "../LoginPage/Login.css";
import EliteMembersimglogin from "../../../Assets/Images/hrms.jpg";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import { Apiurl, SetLoginRole, Token } from "../../../Utils/utils";
import Loader from "../../../Components/loader/loader";
import eliteLoginlogo from '../../../Assets/Images/logo-elite-for login.png'
const Login = () => {
  const navigate = useNavigate();
  const [newPasswordEye, setNewPasswordEye] = useState(false);
  const [changePassword, setChangePassword] = useState('');
  const [username, setUsername] = useState('');
  const [errorusername, setErrorusername] = useState(false);
  const [errorpassword, setErrorpassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const
    handleClickNewPassword = () => {
      setNewPasswordEye(!newPasswordEye);
    };
  const validate = () => {
    if (!username) {
      setErrorusername(true);
      return false;
    }
    if (!changePassword) {
      setErrorpassword(true);
      return false;
    }
    return true;
  };
  const handleLoginNavigate = () => {
    navigate("/SignUp");
  };
  const handleForgotPassword = () => {
    navigate("/ForgotPassword");
  };
  const handleLoginSubmit = (e) => {
    e?.preventDefault();
    if (!validate()) return;
    setLoading(true);
    
    const data = {
      EmailAddress: username,
      Password: changePassword,
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
      },
      data: { data: JSON.stringify(data) },
      url: `${Apiurl()}/Account/LoginUser`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.success) {
          if (e?.data?.message === "TeamLead successfully") {
            toast.success("Team Lead Login Successfully");
          }
          else if (e?.data?.message === 'HR successfully') {
            toast.success("HR Login Successfully");
          }
          else {
            toast.success(e?.data?.message);
          }
          Token(e?.data?.data?.token);
          SetLoginRole(e?.data?.data?.roleName);
          setUsername('');
          setChangePassword('');
          setLoading(false);
          if (e?.data?.data?.roleName === 'Employee' || e?.data?.data?.roleName === 'TeamLead' || e?.data?.data?.roleName === 'HR' || e?.data?.data?.roleName === 'Manager') {
            navigate("/Emp/Dashboard");
          } else {
            navigate("/Adm/Dashboard");
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("Login Error:", err);
        toast.error(
          err?.response?.data?.message || "An error occurred during login."
        );
      });
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <div className="full-page-main">
        <div className="main-container-of-login-page row">
          <div className="login-page-image col-md-6">
            <img src={EliteMembersimglogin} alt="" />
          </div>
          <div className="login-page-form col-md-6">
            <div className="inner-container-of-login-form">
              <div className="eliteLoginlogo-main-div">
                <img src={eliteLoginlogo} alt="" />
              </div>
              <div className="elite-heading-div">
                <h2>Welcome To <span className="elite-heading">Elite</span>  HRMS</h2>
                
                <form onSubmit={(e) => handleLoginSubmit(e)}>
                  {/* <h2 className="signup-heading">Sign in</h2> */}
                  <div className="email-and-password-inputs">
                    <div>
                      <div className="username-content-login">
                        <FloatingLabelInput
                          label="Username*"
                          type="text"
                          onChange={(e) => setUsername(e?.target?.value)}
                          value={username}
                          onBlur={(e) => {
                            if (!e.target.value) {
                              setErrorusername("userdata");
                            } else {
                              setErrorusername("false");
                            }
                          }}
                        />
                        {errorusername === "userdata" && !username ? (
                          <span className="contact_error-login">
                            Username is required.
                          </span>
                        ) : null}
                      </div>
                      <div className="password-floating-login">
                        <FloatingLabelInput
                          label="Password*"
                          type={newPasswordEye ? "text" : "password"}
                          className="login-password-input"
                          onChange={(e) => setChangePassword(e?.target?.value)}
                          value={changePassword}
                          onBlur={(e) => {
                            if (!e.target.value) {
                              setErrorpassword("passworddata");
                            } else {
                              setErrorpassword("false");
                            }
                          }}
                        />
                        {newPasswordEye ? (
                          <AiOutlineEye
                            className="eye-password-login"
                            onClick={() => handleClickNewPassword()}
                          />
                        ) : (
                          <AiOutlineEyeInvisible
                            className="eye-password-login"
                            onClick={() => handleClickNewPassword()}
                          />
                        )}
                        {errorpassword === "passworddata" && !changePassword ? (
                          <span className="contact_error-login">
                            Password is required.
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="remember-me-and-forgot-password">
                    <div className="remember-me-input-label">
                      <input type="checkbox" />
                      <label htmlFor="">Remember me</label>
                    </div>
                    <div className="forgot-password">
                      <a href="" onClick={handleForgotPassword}>
                        Forgot Password?
                      </a>
                    </div>
                  </div>
                  <div className="login-button-login">
                    {/* <button onClick={() => handleLoginSubmit()}>Login</button> */}
                    <button
                      type="Submit"
                      style={{
                        backgroundColor:
                          username && changePassword
                            ? "#3f51b5"
                            : "rgba(0, 0, 0, .12)",
                        color:
                          username && changePassword
                            ? "#fff"
                            : "rgba(0, 0, 0, .38)",
                      }}
                    >
                      Login
                    </button>
                  </div>
                 
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;